export default "__VITE_ASSET__7c58b4a4__"